import { Link } from 'gatsby';
import { EuiButton, EuiSpacer } from '@elastic/eui';
import QICards from 'components/Outdoor_Cameras/IN-5907_HD/Quick_Installation/QICards';
import NavButtons from 'components/Outdoor_Cameras/IN-5907_HD/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  EuiButton,
  EuiSpacer,
  QICards,
  NavButtons,
  BreadCrumbs,
  SEOHelmet,
  React
};